<template>
    <p class="results-count">{{processCount}} {{label}}</p>
</template>

<script>
    import $ from 'jquery';

    export default {
        props: {

        },
        data() {
            return {
                count: 0
            };
        },
        computed: {
            label(){
                if(this.count > 1) {
                    return 'voyages disponibles'
                } else if (this.count == 1) {
                    return 'voyage disponible'
                } else{
                    return `Il n'y a pas de résultats correspondant à votre recherche`
                }
            },
            processCount(){
                if(this.count > 0) {
                    return this.count
                }else{
                    return ''
                }
            }

        },
        mounted() {
            this.count = $('article.cruise-card').length
        },
    }
</script>


// WEBPACK FOOTER //
// assets/js/components/taxonomy-destination/CruiseCount.vue